import axios from "axios";
import { Appconfig } from "../config/AppConfig";

export class ContactusService {
  constructor() {
    const baseUrl = Appconfig.getAPIURI();
    this.Api = `${baseUrl}/contact`;
    Appconfig.getEnv();
  }

  submitContact(contactData) {
    const url = `${this.Api}/submit`;
    return axios.post(url, contactData);
  }
}

export default ContactusService;
